module.exports = __webpack_public_path__ + "img/t_0006.2d546369.gif";